import React, { Component } from 'react'
import { AUTH_TOKEN } from '../../constants'


class MailTemplate extends Component {

  state = {
    updatedAt: "",
    template_type: "",
    market_type: "",
    body: "",
    subject: "",
    id: 0,
  }

  constructor(props) {
    super(props);
    // Don't call this.setState() here!
    this.state = { 
        updatedAt: props.mail_template.updatedAt,
        template_type: props.mail_template.template_type,
        market_type: props.mail_template.market_type,
        body: props.mail_template.body,
        subject: props.mail_template.subject,
        id: props.mail_template.id,
    };
  }

  formatDate(date, isDateTime) {
    return new Intl.DateTimeFormat("de-DE", isDateTime ? {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
        hour:  "2-digit",
        minute: "2-digit",
       second: "2-digit"
    } : {
        year: "numeric",
        month: "numeric",
        day: "2-digit", 
    }).format(new Date(date))
  }
  
  render() {
    const token = localStorage.getItem(AUTH_TOKEN)
    
    let elements = React.Children.toArray(this.props.children)
    let updateButton
    if(elements.length === 1){
        // deleteButton = React.cloneElement(elements[0], {id: this.state.id})
        updateButton = React.cloneElement(elements[0], {id: this.state.id, state: this.state})
    }

    return (
        <tr>
            <td>{this.state.id}</td>
            {/* <td><div>{token && !this.props.locked ?
                <input
                value={this.state.translation}
                onChange={e => this.setState({translation: e.target.value})}
                type="text"
                placeholder="translation"
                /> : this.state.translation}</div></td> */}
            <td><div>{this.state.template_type}</div></td>
            <td><div>{this.state.market_type}</div></td>
            <td><div>{token && !this.props.locked ?
                  <input
                  style={{
                    width: "100%"
                    }}
                  value={this.state.subject}
                  onChange={e => this.setState({subject: e.target.value})}
                  type="text"
                  placeholder="subject"
                  /> : this.state.subject}</div></td>
            <td><div>{token && !this.props.locked ?
            
                <textarea 
                rows={20}
                value={this.state.body}
                onChange={e => this.setState({body: e.target.value})}
                type="text"
                placeholder="body"
                /> :  <pre style={{ whiteSpace: 'pre-wrap' }}>
                <code
                  dangerouslySetInnerHTML={{
                    __html: this.state.body.replace(/</g, '&lt;').replace(/>/g, '&gt;'),
                  }}
                />
              </pre>}</div></td>
            <td><div dangerouslySetInnerHTML={{ __html: this.state.body }}/></td>
            <td><div>{this.formatDate(this.state.updatedAt, true)}</div></td>
            {token && !this.props.locked && <td>{ updateButton }</td>}
            {/* {token && !this.props.locked && <td>{ deleteButton }</td>} */}
        </tr>
        )
    } 

}

export default MailTemplate